module.exports = __webpack_public_path__ + "static/media/27OCHA4.bf3e9c57.jpg";